/**
 * O que o PDV mostra quando existe configuração esperando para entrar.
 *
 * Três situações, e cada uma diz uma coisa diferente para quem está no caixa:
 *
 *  · aguardando o próximo caixa — a Central salvou com "aplicar no próximo
 *    período". A tela NÃO vai mudar sozinha; muda quando este caixa fechar e o
 *    próximo abrir. Quem está operando precisa saber disso, senão vai achar que
 *    a alteração se perdeu.
 *  · a caminho agora — salvo com "aplicar agora"; o worker aplica em segundos e
 *    a tela se atualiza sozinha (useConfigDoPdv).
 *  · conflito — o OPS RECUSOU aplicar, para não escrever por cima de
 *    configuração viva. Isso não se resolve no PDV: é aviso para chamar quem
 *    cuida da Central.
 */
import React from "react";
import { useCombinedStore } from "../store";

const estiloBase: React.CSSProperties = {
  position: "fixed",
  bottom: 12,
  left: 12,
  zIndex: 9000,
  maxWidth: 460,
  padding: "var(--sp-10) calc(var(--u) * 14)",
  borderRadius: 8,
  fontSize: 13,
  lineHeight: 1.35,
  boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
};

const AvisoConfigPendente: React.FC = () => {
  const { subsidiaryDataZustand } = useCombinedStore();
  const pendente = subsidiaryDataZustand?.selectedPdv?.configPendente;

  if (!pendente) return null;

  const aguardando = pendente.aguardandoProximoPeriodo?.length || 0;
  const aCaminho = pendente.aCaminhoAgora || 0;
  const conflitos = pendente.conflitos?.length || 0;

  if (aguardando === 0 && aCaminho === 0 && conflitos === 0) return null;

  return (
    <div>
      {conflitos > 0 && (
        <div
          style={{
            ...estiloBase,
            bottom: 12 + (aguardando > 0 || aCaminho > 0 ? 72 : 0),
            background: "#FDECEA",
            border: "1px solid #E5A29B",
            color: "#8B2A20",
          }}
        >
          <strong>
            {conflitos} alteração(ões) da Central não puderam ser aplicadas.
          </strong>
          <div style={{ marginTop: 4 }}>
            A configuração deste PDV foi preservada. Avise quem cuida da Central:
            o editor está com uma versão diferente da que roda aqui.
          </div>
        </div>
      )}

      {(aguardando > 0 || aCaminho > 0) && (
        <div
          style={{
            ...estiloBase,
            background: "#FFF6E0",
            border: "1px solid #E5C97B",
            color: "#6B5210",
          }}
        >
          {aguardando > 0 && (
            <div>
              <strong>
                {aguardando} alteração(ões) esperando a abertura do próximo caixa.
              </strong>
              <div style={{ marginTop: 4 }}>
                A tela só muda quando este período for fechado e o próximo for
                aberto.
              </div>
            </div>
          )}
          {aCaminho > 0 && (
            <div style={{ marginTop: aguardando > 0 ? 8 : 0 }}>
              {aCaminho} alteração(ões) chegando agora — a tela se atualiza
              sozinha em instantes.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AvisoConfigPendente;
